// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2gvoI","signatureButtonsRight":"ModalSign_signatureButtonsRight__Se447"};